import React, { useEffect, useState } from 'react';

/**
 * What an approver is deciding on for a position fund approval: how the budgeted
 * total moves, and where the variance is drawn from.
 *
 * Fetched on open rather than read off the row, exactly as the modal this
 * replaces does, and the same totals are handed back up as the submitted
 * payload's totalNew/totalOld.
 */
export default function PositionFundBody({ row, myViews, onExtrasChange }) {
    const [data, setData] = useState({
        contingencyAvailable: 0,
        totalOld: 0,
        totalNew: 0,
        positionable: undefined,
    });

    const [failed, setFailed] = useState(false);

    const record = row?.record ?? {};

    useEffect(() => {
        if (!record.id) {
            return;
        }

        setFailed(false);

        axios
            .get(myViews.fetch_position_fund_approval_url.replace('POSITION_FUND_APPROVAL_ID', record.id))
            .then(({ data: fetched }) => {
                setData(fetched);
                onExtrasChange?.({ totals: { totalNew: fetched.totalNew, totalOld: fetched.totalOld } });
            })
            .catch(() => {
                // The zeroed defaults are NOT safe to submit: the server consumes
                // totalNew/totalOld to compute the contingency draw and writes the
                // result, so posting 0/0 corrupts a department or cost centre's
                // contingency. Approve is withheld until real figures arrive.
                setFailed(true);
                onExtrasChange?.({ totalsUnavailable: true });
            });
    }, [record.id]);

    const fromContingency = Number(data.contingencyAvailable) || 0;
    const fromCentral = (Number(data.totalNew) || 0) - (Number(data.totalOld) || 0) - fromContingency;

    if (failed) {
        return (
            <p className="modal__heading tw-text-red">
                {$t('The figures for this item could not be loaded, so it cannot be approved right now. You can still reject it.')}
            </p>
        );
    }

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="modal__text">
                {$t('Committing this position will change the total budgeted amount from {{from}} to {{to}}.', {
                    from: data.totalOld,
                    to: data.totalNew,
                })}
            </p>
            <p className="modal__text">
                {$t('The variance of {{amount}} will be taken from contingency of the {{positionable}}.', {
                    amount: fromContingency.toFixed(2),
                    positionable: data.positionable,
                })}
            </p>
            <p className="modal__text">
                {$t('The additional amount of {{amount}} will be taken from central contingency.', { amount: fromCentral.toFixed(2) })}
            </p>
        </div>
    );
}
